import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Features() {
    return (
        <div className="bg-[#F5F9FF] min-h-screen">

            {/* NAVBAR */}
            <Navbar />

            {/* HERO */}
            <section className="py-20 text-center">
                <div className="max-w-7xl mx-auto px-6">

                    <h1 className="text-[42px] md:text-[26px] font-bold text-[#2563EB]">
                        Features of WamGlammz - Your Beauty & Lifestyle Booking Platform
                    </h1>
                    <h2 className="text-[42px] md:text-[26px] font-bold text-[#2563EB]">
                        All-in-One Beauty Marketplace
                    </h2>
                    <p className="mt-4 text-gray-600 text-[18px] max-w-8xl mx-auto">
                        WamGlammz brings makeup artists, hairstylists, photographers, choreographers, seamstresses, and more ✨ together in one trusted platform. Clients can easily find, compare, and book top-rated professionals all in one place.
                    </p>

                </div>
            </section>

            {/* FEATURES GRID */}
            <section className="max-w-5xl mx-auto px-6 md:px-12">

                <div className="grid md:grid-cols-2 gap-8">

                    {/* 1 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            All-in-One Beauty Marketplace
                        </h3>

                        <p className="text-gray-600 text-sm leading-[26px]">
                            Discover makeup artists, hairstylists, photographers, choreographers, and more — all in one trusted platform.
                        </p>
                    </div>

                    {/* 2 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Smart Booking & Real-Time Availability
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Easy online booking (no calls needed)</li>
                            <li>• Calendar integration & time slots</li>
                            <li>• Automated reminders via email/SMS</li>
                        </ul>
                    </div>

                    {/* 3 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Professional Marketplace with Portfolios
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Explore local experts & portfolios</li>
                            <li>• Reviews & ratings from real clients</li>
                            <li>• Transparent pricing & service details</li>
                        </ul>
                    </div>

                    {/* 4 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Secure & Hassle-Free Payments
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Secure payment gateways</li>
                            <li>• Transparent pricing before booking</li>
                            <li>• Instant confirmations & receipts</li>
                        </ul>
                    </div>

                    {/* 5 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Rewards, Referrals & Loyalty
                            <span className="text-sm text-gray-400 ml-2">(Coming Soon)</span>
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Earn rewards for referrals</li>
                            <li>• Loyalty benefits & offers</li>
                            <li>• Seasonal promotions</li>
                        </ul>
                    </div>

                    {/* 6 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Flexible Service Locations
                        </h3>

                        <p className="text-gray-600 text-sm leading-[26px]">
                            Book services at home, studios, events, weddings, pageants, photoshoots, and more.
                        </p>
                    </div>

                    {/* 7 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Empowering Freelancers & Businesses
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Tools for freelancers & salons</li>
                            <li>• Increased visibility & bookings</li>
                            <li>• Community-focused platform</li>
                        </ul>
                    </div>

                    {/* 8 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Mobile-Friendly Experience
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Book and manage services on your phone</li>
                            <li>• Real-time notifications & updates</li>
                            <li>• Seamless user experience</li>
                        </ul>
                    </div>

                </div>

            </section>

            {/* PREMIUM CTA SECTION */}
            <section className="max-w-5xl mx-auto px-6 md:px-12 mt-20">

                <div className="bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF] text-white rounded-2xl p-10 text-center">

                    <h2 className="text-2xl font-semibold">
                        Experience Beauty, Simplified
                    </h2>

                    <p className="mt-4 text-blue-100 max-w-2xl mx-auto leading-[26px]">
                        WamGlammz combines technology, beauty, and community to create a seamless booking experience for everyone.
                    </p>

                </div>

            </section>

            {/* PREMIUM SEPARATOR */}
            <div className="relative">
                <div className="h-20 bg-gradient-to-b from-transparent to-[#F5F9FF]" />
                <div className="flex justify-center">
                    <div className="w-[60%] h-[1px] bg-gradient-to-r from-transparent via-blue-300 to-transparent" />
                </div>
            </div>

            {/* FOOTER */}
            <Footer />

        </div>
    );
}